import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RestResponse } from 'app/modules/common/entities/rest.response.generic.model';
import { TaskCreationOperation } from 'app/modules/common/enums/task-create-operation-enum';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SharedService } from 'app/modules/common/services/shared-service';
import { Empresa } from 'app/modules/common/types/empresa.type';
import { Medico } from 'app/modules/common/types/medico.type';
import { Trabajador } from 'app/modules/common/types/employee/trabajador.type';
import { Usuario } from 'app/modules/common/types/usuario.type';
import { EmpresaService } from 'app/modules/company-view/services/empresa.service';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import moment, { Moment } from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { TaskSaveModel } from '../entities/TaskSaveModel';
import { TaskSaveService } from './task-save.service';
import { AuthorType } from 'app/modules/common/services/author-component.service';
import { LeaveService } from 'app/modules/leave/services/leave.service';
import { ApiCallsHelper } from 'app/modules/common/helpers/ApiCallsHelper';
import { Baja } from 'app/modules/common/types/baja.type';
import { AuthorViewValue } from 'app/modules/common/components/author/author.component';
import { map } from 'rxjs/operators';
import Utils from 'app/Utils';


type DefaultFormValuesParams = {
    tarea?: number;
    tipoAutor?: AuthorViewValue;
    medicoId?: number;
    autor?: string;
    fecha?: Moment;
};

type Author = {
    tipo?: AuthorViewValue;
    usuario?: string;
    medico?: string;
    coordinator?: string;
    nombre?: string;
    medicoId?: number;
};

@Injectable({
    providedIn: 'root',
})
export class TaskManagementService {
    public TaskManagementForm: UntypedFormGroup;
    public SelectedTask: any;
    public LeaveId: number;
    private taskDefList: any[] = [];

    public citarBajaNueva:string;
    public bajaNueva:string;

    /**
     * Will be used to notify when the default task changes
     */
    public defaultTaskSet = new BehaviorSubject<number>(null);

    constructor(
        private formBuilder: UntypedFormBuilder,
        private empresaService: EmpresaService,
        private sharedService: SharedService,
        private medicoService: DoctorService,
        private employeeService: EmployeeService,
        private taskSaveService: TaskSaveService,
        private leavesService: LeaveService
    ) {}

    public initTaskForm(leaveId: number): void {
        this.LeaveId = leaveId;

        const existingValues = this.TaskManagementForm?.value;

        this.TaskManagementForm = this.formBuilder.group({
            Tarea: [existingValues?.Tarea ?? null, Validators.required],
            TaskService: [false],
            Fecha: [null, [Validators.required]],
            Hora: [null],
            Observation: ['',Validators.maxLength(250)],
            Author: this.formBuilder.group({
                Tipo: ['', Validators.required],
                robutsAuthorType: [''],
                Usuario: [''],
                Medico: [''],
                Coordinator: [''],
                Nombre: [''],
                MedicoId: [''],
            }),
        });

        // listen for task type changes
        // this.TaskManagementForm.get('Tarea').valueChanges.subscribe(
        //     async (taskType: number) => {
        //         await this.onTaskTypeChanges(taskType);
        //     }
        // );
    }

    public setSelectedTask(taskDef: any): void {
        this.SelectedTask = taskDef;
    }

    public markFormGroupTouched(formGroup: UntypedFormGroup): void {
        (Object as any).values(formGroup.controls).forEach((control) => {
            control.markAsTouched();
            if (control.controls) {
                this.markFormGroupTouched(control);
            }
        });
    }
    public listPruebas() : Observable<any>  {
        return this.sharedService.getPruebasList()
        .pipe(map(resp => {
            return resp.result.map(element => {
                return { value: element.pruebaId, viewValue: element.tipoPrueba };
            });
        }));
    }

    public listEspecialista() : Observable<any>  {
        return this.sharedService.getEspecialidadList()
        .pipe(map(resp => {
            return resp.result.map(element => {
                return { value: element.especialistaId, viewValue: element.tipoEspecialista };
            });
        }));
    }
    /**
     * Build the task model to be saved
     */
    public getTaskSaveModel(): TaskSaveModel {
        const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        const saveModel = new TaskSaveModel();
        saveModel.BajaId = this.LeaveId;

        let _selectedTask;
        if (this.SelectedTask) _selectedTask = this.SelectedTask;
        else {
            const selectedTaskDefId =
                this.TaskManagementForm.get('Tarea').value;
            _selectedTask = this.taskDefList.filter(
                (x) => x.id === selectedTaskDefId
            )[0];
        }

        saveModel.Tipo = _selectedTask.id;
        saveModel.Tarea1 = _selectedTask.espanyol;

        saveModel.Fecha = DateHelper.getUTCDateString(
            DateHelper.getNativeDate(this.TaskManagementForm.get('Fecha').value)
        );
        saveModel.Hora = this.TaskManagementForm.get('Hora').value;
        saveModel.Sme = this.TaskManagementForm.get('TaskService').value
            ? 'S'
            : 'N';
        saveModel.Usuario = currentUser.abreviacion;
        saveModel.TipoAutor = this.TaskManagementForm.get('Author.Tipo').value;
        saveModel.Autor = this.TaskManagementForm.get('Author.Nombre').value;
        //saveModel.Medico = this.TaskManagementForm.get('Author.Medico').value;
        saveModel.MedicoId = this.TaskManagementForm.get('Author.MedicoId').value;
        saveModel.Comentario = this.TaskManagementForm.get('Observation').value;
        return saveModel;
    }

    /**
     * Set default values of the task form depending on the operator type
     * @param operatorType Operator who wants to create the task
     */
    public async setTasksDefaultValues(operatorType: TaskCreationOperation) {
        switch (operatorType) {
            case TaskCreationOperation.CreatingLeave:
                await this.defaultValuesWhenCreatingLeave();
                break;

            case TaskCreationOperation.FromMainPopup:
                await this.defaultValuesFormNormalTasks();
                break;
        }
    }

    /**
     * Set default values when creating a task from employee view
     */
    private async defaultValuesFormNormalTasks() {
        // just set the today date as default
        this.setDaefaultFormValues({});
    }

    /**
     * Set default values of task form when creating a leave
     */
    private async defaultValuesWhenCreatingLeave() {
        const employeeId = parseInt(localStorage.getItem('EmplooyeeID'));
        const employee = await this.getEmployee(employeeId);
        if (!employee) return;

        const company = await this.getEmpresa(employee.empresaId);
        if (!company) return;

        // get task definitions
        this.setTaskDefinitions(employeeId);

        const companyDoctor =
            company.medicoId === null
                ? null
                : await this.getMedico(company.medicoId);
        const companyPrimaryContact =
            company.primerContacto === null
                ? null
                : await this.getMedico(company.primerContacto);

        if (employee.citarBajaNueva === 'S') {
            this.citarBajaNueva="S";

            this.setDaefaultFormValues({
                tarea: 13001,
                tipoAutor: 'Administrativo asignado',
                medicoId: null,
                autor: company.administrativa,
            });
        } else {
            this.bajaNueva=company.bajaNueva;
            switch (company.bajaNueva) {
                case 'CONTACTO':
                    this.setDaefaultFormValues({
                        tarea: 31109,
                        tipoAutor: 'Otro médico',
                        medicoId: company.primerContacto,
                        autor: companyPrimaryContact?.nombre,
                    });
                    break;

                case 'DOMICILIO':
                    this.setDaefaultFormValues({
                        tarea: 30109,
                        tipoAutor: 'Otro médico',
                        medicoId: company.medicoId,
                        autor: companyDoctor?.nombre,
                    });
                    break;

                case 'ADMIN':
                    this.setDaefaultFormValues({
                        tarea: 13101,
                        tipoAutor: 'Administrativo asignado',
                        medicoId: null,
                        autor: company.administrativa,
                    });
                    break;
            }
        }
    }

    private setTaskDefinitions(employeeId: number) {
        this.taskSaveService
            .getDefTareaForTaskDropdown(0, employeeId)
            .subscribe((res) => {
                if (res) {
                    this.taskDefList = res.result;
                }
            });
    }

    /**
     * Set default values of task form when creating a new leave.\
     * tarea: task type\
     * tipoAutor: author type\
     * medicoId: if author is a doctor, doctor ID\
     * fecha: task date. default value is today
     */
    private setDaefaultFormValues({
        tarea,
        tipoAutor,
        medicoId,
        autor,
        fecha,
    }: DefaultFormValuesParams) {
        this.TaskManagementForm.controls.Tarea.setValue(tarea);
        this.TaskManagementForm.controls.Fecha.setValue(fecha ?? moment());

        this.setAuthor({
            tipo: tipoAutor,
            medicoId: medicoId,
            nombre: autor,
        });

        // notify the selected task change
        this.defaultTaskSet.next(tarea);
    }

    /**
     * Get company data
     * @param emprssaId Company ID
     * @returns Company data
     */
    public async getEmpresa(emprssaId: number) {
        try {
            const res: RestResponse<Empresa> = await this.empresaService
                .GetEmpresaById(emprssaId)
                .toPromise();

            if (res.code === 0) {
                return res.result;
            } else {
                console.error('Server error: ' + res.message);
                this.sharedService.ShowSnackBar(
                    'Lo siento, la obtención de los datos de la empresa ha fallado'
                );
            }
        } catch (err) {
            console.error(err);
            this.sharedService.ShowSnackBar(
                'Lo siento, la obtención de los datos de la empresa ha fallado'
            );
        }

        return null;
    }

    /**
     * Get doctor
     */
     public async getMedico(medicoId: number) {
        try {
            const res: RestResponse<Medico> = await this.medicoService
                .GetDoctor(medicoId.toString())
                .toPromise();

            if (res.code === 0) {
                return res.result;
            } else {
                console.error('Server error: ' + res.message);
                this.sharedService.ShowSnackBar(
                    'Lo siento, la obtención de los datos del médico ha fallado'
                );
            }
        } catch (err) {
            console.error(err);
            this.sharedService.ShowSnackBar(
                'Lo siento, la obtención de los datos del médico ha fallado'
            );
        }

        return null;
    }

    /**
     * Get employee data
     */
    public async getEmployee(employeeId: number) {
        try {
            const res: RestResponse<Trabajador> = await this.employeeService
                .GetTrabajador(employeeId)
                .toPromise();

            if (res.code === 0) {
                return res.result;
            } else {
                console.error('Server error: ' + res.message);
                this.sharedService.ShowSnackBar(
                    'Lo siento, la obtención de los datos de los empleados ha fallado'
                );
            }
        } catch (err) {
            console.error(err);
            this.sharedService.ShowSnackBar(
                'Lo siento, la obtención de los datos de los empleados ha fallado'
            );
        }

        return null;
    }

    /**
     * Get doctor of given leave
     */
    private async getLeaveDoctor(leaveId: number): Promise<Medico> {
        const leave = await ApiCallsHelper.toPromise<Baja>(
            this.leavesService.GetLeaveById(this.LeaveId.toString())
        );

        return Boolean(leave.medicoId)
            ? await this.getMedico(leave.medicoId)
            : null;
    }

    /**
     * Event handler for task type changes
     */
    private async onTaskTypeChanges(taskType: number): Promise<void> {
        const author: Omit<Author, 'Usuario' | 'Medico' | 'Coordinator'> = {};

        // if this is a medical task, set default medical task doctor as author
        if (taskType >= 30000 && taskType <= 39999) {
            const [doctor, authorType] =
                await this.getDefaultMedicalTaskDoctor(taskType);
            if (doctor) {
                author.tipo = authorType;
                author.medicoId = doctor.medicoId;
                author.medico = doctor.medicoId.toString();
                //author.medico = doctor.nombre;
                author.nombre = doctor.nombre;
            }
        } else {
            // otherwise get default admin for tasks
            const [userAbrev, authorType] = await this.getDefaultTasksAdmin();
            if (userAbrev) {
                author.tipo = authorType;
                author.nombre = userAbrev;
            }
        }

        this.setAuthor(author);
    }

    /**
     * Set author form values.  Default value of any parameter is null
     */
    private setAuthor({
        tipo = null,
        medicoId = null,
        nombre = null,
    }: Omit<Author, 'Usuario' | 'Medico' | 'Coordinator'>): void {
        this.TaskManagementForm.get(['Author', 'robutsAuthorType']).setValue(
            tipo
        );
        this.TaskManagementForm.get(['Author', 'MedicoId']).setValue(medicoId);
        this.TaskManagementForm.get(['Author', 'Nombre']).setValue(nombre);
        if(tipo=="Otro médico")
        {
            this.TaskManagementForm.get(['Author', 'Medico']).setValue(medicoId);
        }
        this.TaskManagementForm.get('Author').updateValueAndValidity();
    }

    /**
     * Get default dcotor for medical tasks. If doctor does not exist, return null
     */
    private async getDefaultMedicalTaskDoctor(taskid): Promise<
        [Medico, AuthorViewValue]
    > {
        let doctor: Medico = null;
        let medicoId: number;
        let authorType: AuthorViewValue = null;

        // check if current user is a doctor
        const employeeId = parseInt(localStorage.getItem('EmplooyeeID'));
        const employee = await this.getEmployee(employeeId);
        const company = await this.getEmpresa(employee.empresaId);

        const currentUser = this.sharedService.getCurrentUser() as Usuario;
        if(taskid==31109)
        {
            if (Boolean(company.primerContacto)) {
                medicoId = company.primerContacto;
                authorType = 'Otro médico';
            }
        }else if(taskid==30109)
        {
            if (Boolean(company.medicoId)) {
                medicoId = company.medicoId;
                authorType = 'Otro médico';
            }
        }
        // if (Boolean(currentUser.medicoId)) {
        //     medicoId = currentUser.medicoId;
        //     authorType = 'Yo';
        // }

        
        // other wise set leave's doctor as author
        else if (Boolean(this.LeaveId)) {
            doctor = await this.getLeaveDoctor(this.LeaveId);
            authorType = 'Médico asignado';
        }

        if (!Boolean(doctor) && Boolean(medicoId)) {
            doctor = await this.getMedico(medicoId);
        }

        return [doctor, authorType];
    }

    /**
     * Get only the abreviation of the default user of a task
     */
    private async getDefaultTasksAdmin(): Promise<[string, AuthorViewValue]> {
        let userAbrev: string = null;
        let authorType: AuthorViewValue = null;
        const currentUser = this.sharedService.getCurrentUser() as Usuario;

        // id current user is a doctor, return company's admin
        if (Boolean(currentUser.medicoId)) {
            const employeeId = parseInt(localStorage.getItem('EmplooyeeID'));
            const employee = await this.getEmployee(employeeId);
            if (employee) {
                const company = await this.getEmpresa(employee.empresaId);
                userAbrev = company.administrativa;
                authorType = 'Administrativo asignado';
            }
        } else {
            userAbrev = currentUser.abreviacion;
            authorType = 'Yo';
        }

        return [userAbrev, authorType];
    }
}
